export default {"src":"/_next/static/media/devops.d526d8a0.svg","height":49,"width":94};